module.exports = __webpack_public_path__ + "img/26_35.8834ad4c.png";